module.exports = {"placeholder":"Search"}


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInputCopy.json
// module id = ./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInputCopy.json
// module chunks = 4